import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin/AdminService';
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
import { CoachService } from '../../services/coach/CoachService';
import { AssignedComponent } from '../../coach/assigned/assigned.component';
import { CoachCompletedAssessmentsComponent } from '../../coach/completed-assessments/completed-assessments.component';
import { ExpiredComponent } from '../../coach/expired/expired.component';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { ClientsService } from '../../services/client/ClientsService';
import { UserCoachesListComponent } from '../user-coaches-list/user-coaches-list.component';
import { GridApi } from 'ag-grid';


@Component({
  selector: 'app-user-personal-data',
  templateUrl: './user-personal-data.component.html',
    styleUrls: ['./user-personal-data.component.scss'],
    providers: [AssignedComponent, CoachCompletedAssessmentsComponent, DownloadAssessmentManager, ExpiredComponent]

})
export class UserPersonalDataComponent implements OnInit {

    @ViewChild(UserCoachesListComponent, {static: false}) userCoachesListComponent: UserCoachesListComponent;

    selectedUserId: number;
    firstName: string;
    lastName: string;
    email: string;
    newEmail: string;
    userType: string;
    registrationDate: string;
    status: boolean;
    contactId: number = 0;
    madeChanges: boolean = false;
    isClientOrRater: boolean;
    selfAssessments: any = [];
    assessments360: any = [];
    currentSelectedTab: number = 0;
    restoring: boolean = false;
    saving: boolean = false;
    userInfo = {
        firstName: "",
        lastName: "",
        email: "",
        currentPassword: "",
        password1: "",
        password2: "",
        ELICertified: true
    }
    passwordIsValid: number;
    myColors = ['#8b0000', '#FF6D00', '#ffa500', '#AEEA00', '#00C853'];
    validName: boolean = false;
    loading: boolean = false;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _ClientsService: ClientsService,
        private _AssignedComponent: AssignedComponent,
        private _CoachCompletedAssessmentsComponent: CoachCompletedAssessmentsComponent,
        private _ExpiredComponent: ExpiredComponent,
        public _Globals: Globals,
        private _Toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
        private _CryptoJs: CryptoJs)
    {
        this.activatedRoute.params.subscribe(params => {
            this.selectedUserId = parseInt(params['id']);
            this._Globals.assignedUserId = this.selectedUserId;
            this._Globals.completedUserId = this.selectedUserId;
            this._Globals.expiredUserId = this.selectedUserId;
        });
    }

    ngOnInit() {
        this.getUserPersonalData(this.selectedUserId, false);

        this.getCoachProfile();
    }

    ngOnDestroy() {
        this._Globals.assignedUserId = undefined;
        this._Globals.completedUserId = undefined;
        this._Globals.expiredUserId = undefined;
    }

    getUserPersonalData(selectedUserId: number, restore: boolean) {
        this._AdminService.getUserPersonalData(selectedUserId).subscribe((data: any) => {
            console.log('response_getUserPersonalData', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.firstName = _data.vg6;
                this.lastName = _data.hj7; // 'Doe%';

                this.checkForSpecialCharacters(this.firstName, 'firstName', true);
                this.checkForSpecialCharacters(this.lastName, 'lastName', true)

                this.email = _data.sr3;
                this.newEmail = this.email;
                switch (_data.km1) {
                    case 1:
                        this.userType = 'Administrator';
                        break;

                    case 2:
                        this.userType = 'Coach';
                        break;

                    case 3:
                        if (this.contactId != 0) {
                            this.userType = 'Student';
                        } else {
                            this.userType = 'Client';
                        }
                        break;

                    case 4:
                        if (this.contactId != 0) {
                            this.userType = 'Student';
                        } else {
                            this.userType = 'Rater';
                        }
                        break;

                    case 5:
                        this.userType = 'Manager';
                        break;
                }              
                this.registrationDate = _data.tu6;
                this.status = (_data.zp4 == 1)? true: false;
                this.contactId = _data.by3;

                if (this.userType != 'Client' && this.userType != 'Rater') {
                    $('input[name="status"]').attr('disabled', 'disabled');
                    $('#firstName').attr('disabled', 'disabled');
                    $('#lastName').attr('disabled', 'disabled');
                    this.isClientOrRater = false;
                    this.getAvailableAssessmentsAuthorized(false);
                } else {
                    this.isClientOrRater = true;
                }

                if (restore) {
                    this.madeChanges = false;
                    this._Toastr.success('Data restored successfully', 'ELI');
                } 

                this.restoring = false;
            }
        })
    }

    checkForSpecialCharacters(text: string, elementId: string, firstCall:boolean) {
        console.log(text);
        var format = /[ `!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
        if (format.test(text)) {
            $('#' + elementId).addClass('colorRed');
            $('#' + elementId).closest('.col-sm-9').find('.errorMessage').addClass('colorRed').removeClass('d-none');
            this.validName = false;
        } else {
            $('#' + elementId).removeClass('colorRed');
            $('#' + elementId).closest('.col-sm-9').find('.errorMessage').removeClass('colorRed').addClass('d-none');
            this.validName = true;
        }

        if (!firstCall) this.madeChanges = true;
    }

    changeStatus(id:string, value:string) {
        console.log('event change');
        this.madeChanges = true;
        this.status = !this.status;

        if (value == "") {
            setTimeout(() => {
                $('#' + id).val(0);
            },100)
        }
    }

    tabSelect(tabIndex) {
        console.log(tabIndex);
        this.currentSelectedTab = tabIndex;
        //this.madeChanges = false;
        this.clearPasswordInputs();

        switch (tabIndex) {
            case 1:
                this.showAvailableTabContent();
                break;

            case 1.1:
                //this._Globals.assignedUserId = this.selectedUserId;
                this._AssignedComponent.getCoachAssignedAssessmentsByType(1);
                this._AssignedComponent.getCoachAssignedAssessmentsByType(2);
                this._Globals.assignedAssessmentType = 1.1;
                this._Globals.assignedCanDelete = false;
                this._Globals.assignedCanCopy = false;
                this._Globals.assignedCanAddRaters = false;
                this._Globals.assignedCanUpdate = false;
                this._Globals.assignedCanSend = false;
                this._Globals.assignedCanSendReminder = false;
                var w = window.innerWidth;
                if (w < 855) {
                    $('h1').css("padding-bottom", "35px");
                }
                this._AssignedComponent.showAssignedTabs();
                break;

            case 1.2:
                //this._Globals.completedUserId = this.selectedUserId;
                this._CoachCompletedAssessmentsComponent.sizeToFit(this._Globals.completedAssessmentGridApi);
                this._CoachCompletedAssessmentsComponent.getCoachCompletedAssessmentsByType(1);
                this._CoachCompletedAssessmentsComponent.getCoachCompletedAssessmentsByType(2);
                this._Globals.completedCanEnableResults = false;
                $('h1').css("padding-bottom", "0px");
                this._CoachCompletedAssessmentsComponent.showCompletedTabs();
                break;

            case 1.3:
                //this._Globals.expiredUserId = this.selectedUserId;
                this._ExpiredComponent.sizeToFit(this._Globals.expiredAssessmentGridApi);
                this._ExpiredComponent.getCoachExpiredAssessmentsByType(1);
                this._ExpiredComponent.getCoachExpiredAssessmentsByType(2);
                this._Globals.expiredAssessmentType = 3.1;
                this._Globals.expiredCanDelete = false;
                this._Globals.expiredCanCopy = false;
                this._Globals.expiredCanAddRaters = false;
                this._Globals.expiredCanExtend = false;
                this._Globals.expiredCanSend = false;
                this._Globals.expiredCanSendReminder = false;
                var w = window.innerWidth;
                if (w < 855) {
                    $('h1').css("padding-bottom", "30px");
                }
                this._ExpiredComponent.showExpiredTabs();
                break;

            case 3:
                this.madeChanges = false;
                break;
        }
    }

    restore() {
        if (this.madeChanges) {
            this.restoring = true;
            switch (this.currentSelectedTab) {
                case 0:
                    this.getUserPersonalData(this.selectedUserId, true);
                    break;
                case 1:
                    this.getAvailableAssessmentsAuthorized(true);
                    break;
                case 2:
                    this.clearPasswordInputs();
                    this.madeChanges = false;
                    this.restoring = false;
                    break;
            }
        }

    }

    saveChanges() {
        if (this.madeChanges) {
            this.saving = true;
            console.log('save changes');

            switch (this.currentSelectedTab) {
                //personal data
                case 0:
                    if (!this.validName) {
                        this._Toastr.warning('First name or Last name contains invalid characters', 'ELI');
                        this.saving = false;
                        return;
                    }

                    let emailChanged = (this.newEmail || '').trim().toLowerCase() != (this.email || '').trim().toLowerCase();

                    if (emailChanged) {
                        if (!this.validateEmail(this.newEmail.trim())) {
                            this.saving = false;
                            return;
                        }
                        this.updateUserEmail(() => this.updatePersonalData());
                    } else {
                        this.updatePersonalData();
                    }

                    break;

                //assessments
                case 1:
                    this.updateCoachAvailableAssessments();
                    break;

                //password
                case 2:
                    this.updatePassword();
                    break;
            }

            
        }
    }

    updatePersonalData() {
        let data = {
            "bn7": this.selectedUserId,
            "vg6": this.firstName,
            "hj7": this.lastName,
            "zp4": (this.status) ? 1 : 0
        };

        this._AdminService.postUpdatePersonalData(this._CryptoJs.encrypt(JSON.stringify(data), 'Ts6v9y$B&EXJ@PcQfTjWnZP4t70!z%7*')).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                //let _data = JSON.parse(data.result);
                console.log('postAdminUpdatePersonalData_response', data.result.Result);
                switch (data.result.Result) {
                    case 0:
                        //0 : Error.
                        this._Toastr.error('We are sorry. An unexpected error happened when trying update the user personal data', 'ELI');
                        break;
                    case 1:
                        //1 : Ok.Entered password is different from the one at the invitation email.No message to show
                        this._Toastr.success('User personal data updated successfully');
                        this.madeChanges = false;
                        break;
                }
                this.saving = false;
            }
        });
    }

    updateUserEmail(onSuccess: () => void) {
        this._AdminService.postUpdateUserEmail(this.selectedUserId, this.newEmail.trim()).subscribe((data: any) => {
            console.log('postUpdateUserEmail_response', data);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 1:
                        //1 : Ok. Email updated
                    case 2:
                        //2 : New email is the same as the current one. No changes
                        this.email = this.newEmail.trim();
                        this.newEmail = this.email;
                        onSuccess();
                        return;
                    case -1:
                        //-1 : User not found
                        this._Toastr.warning("We are sorry. We couldn't find the selected user at the database", 'ELI');
                        break;
                    case -2:
                        //-2 : Email already in use by another user
                        this._Toastr.warning('The email address is already in use by another user', 'ELI');
                        break;
                    case -4:
                        //-4 : Invalid parameters
                        this._Toastr.warning('Please enter a valid email address', 'ELI');
                        break;
                    case 0:
                        //0 : Unexpected error
                    default:
                        this._Toastr.error('We are sorry. An unexpected error happened when trying to update the user email', 'ELI');
                }
                this.saving = false;
            }
        }, () => {
            this._Toastr.error('We are sorry. An unexpected error happened when trying to update the user email', 'ELI');
            this.saving = false;
        });
    }

    getAvailableAssessmentsAuthorized(restore:boolean) {
        this._CoachService.getAvailableAssessmentsAuthorized(this.selectedUserId).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getAvailableAssessmentsAuthorized_response', _data);
                if (_data.length != 0) {
                    this.selfAssessments = _data[_data.findIndex(x => x.AssessmentId === 1)];
                    this.assessments360 = _data[_data.findIndex(x => x.AssessmentId === 34)];
                } else {
                    this.selfAssessments = {
                        Amount: 0,
                        AssessmentId: 1,
                        Id: 3,
                        Is360: false
                    };

                    this.assessments360 =  {
                        Amount: 0,
                        AssessmentId: 34,
                        Id: 3,
                        Is360: true
                    };
                }

                if (restore) {
                    this.madeChanges = false;
                    this._Toastr.success('Data restored successfully', 'ELI');
                } 

                this.restoring = false;
            }
        });
    }

    showAvailableTabContent() {
        $('#assessmentsTab li').removeClass('active');
        $('.assessmentsContent > div').removeClass('active in');
        $('#assessmentsTab li').eq(0).addClass('active');
        $('#assessmentsComponentTab1').addClass('active in');
    }

    getCoachProfile() {

        this._CoachService.getCoachProfile(this.selectedUserId).subscribe((data: any) => {
            console.log('getCoachProfile_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log(_data);
                this.userInfo.firstName = _data.FirstName;
                this.userInfo.lastName = _data.LastName;
                this.userInfo.email = _data.Email;
                this.userInfo.ELICertified = _data.ELICertified;
            }
        });
    }

    updateCoachAvailableAssessments() {
        let data = [
            {
                "dr3": this.selectedUserId,
                "bg5": 1,
                "la2": this.selfAssessments.Amount
            },
            {
                "dr3": this.selectedUserId,
                "bg5": 34,
                "la2": this.assessments360.Amount
            }
        ]

        this._CoachService.postUpdateCoachAvailableAssessments(this._CryptoJs.encrypt(JSON.stringify(data), 'Ts6v7y$B&EXJ@FcQfTjWnZP4t70!z%7*')).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('postUpdateCoachAvailableAssessments_response', data.result.Result);
                switch (data.result.Result) {
                    case 0:
                        //0 : Error.
                        this._Toastr.error('We are sorry. An unexpected error happened when trying update the assessments amount', 'ELI');
                        break;
                    case 1:
                        //1 : Ok.Entered password is different from the one at the invitation email.No message to show
                        this._Toastr.success('Assessments amount updated successfully');
                        this.madeChanges = false;
                        break;
                }
                this.saving = false;
            }
        });
    }

    //PASSWORD
    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    validateEmail(email: string): boolean {
        console.log("email", email);

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) return true;
        else {
            this._Toastr.warning('Please enter a valid email address', "ELI");
            return false;
        }
    }

    removeMessage() {
        $('#errorPasswordMessage').text('');
    }

    confirmationFail() {
        if (this.userInfo.password1 == "" && this.userInfo.password2 == "") {
            $('#errorPasswordMessage').text('');
        }

        if (this.userInfo.password1 != "" && this.userInfo.password2 != "") {
            if (this.userInfo.password1 !== this.userInfo.password2) {
                this._Toastr.warning("Confirm password must be the same as the new password", "ELI");
                $('#errorPasswordMessage').text('Confirm password does not match');
                $('.pass2').removeClass('passMatch');
                $('.pass2').addClass('passNotMatch');
            } else {
                $('#errorPasswordMessage').text('');
                $('.pass2').removeClass('passNotMatch');
                $('.pass2').addClass('passMatch');
            }
        }
    }

    validForm() {
        console.log('validForm');
        if ((this.userInfo.password1 !== this.userInfo.password2) || (this.userInfo.password1 == "" && this.userInfo.password2 == "")) {
            $('.pass2').removeClass('passMatch');
            $('.pass2').addClass('passNotMatch');
            this.madeChanges = false;
            return false;
        } else {
            $('.pass2').removeClass('passNotMatch');
            $('.pass2').addClass('passMatch');
            if (this.passwordIsValid >= 3) this.madeChanges = true;
        }
        return true;
    }

    updatePassword() {
        if (this.validForm() && this.passwordIsValid) {

            //console.log('encrypCP', this.encrypt(this.userInfo.currentPassword));
            //console.log('encrypCP', this.encrypt(this.userInfo.password1));

            let data = {
                "n5": this.selectedUserId,
                "j1": this.userInfo.password1
            };

            $('body').css('cursor', 'progress');
            this._AdminService.postAdminResetPassword(this._CryptoJs.encrypt(JSON.stringify(data), 'Ks6u9y$B&EXH@PcQfTjWnZP4t33!z%7*')).subscribe((data: any) => {

                console.log('response_postUpdatePasswordFromProfile', data);
                $('body').css('cursor', 'default');

                switch (data.result.Result) {
                    case -2:
                        //-2 No user found.
                        this._Toastr.warning("The selected user is either a coach or a student. You cannot reset the password for such user types by using this option", 'ELI');
                        break;
                    case -1:
                        //-1 Entered password is the same at the one at the invitation email.
                        this._Toastr.warning("We are sorry. We couldn't find the selected user at the database", 'ELI');
                        break;
                    case 0:
                        //0 : Error.
                        this._Toastr.error('We are sorry. An unexpected error happened when trying to reset the selected user password', 'ELI');
                        break;
                    case 1:
                        //1 : Ok.Entered password is different from the one at the invitation email.No message to show
                        this._Toastr.success('Password reset successfully');
                        this.clearPasswordInputs();
                        this.madeChanges = false;
                        break;
                    default:
                        this._Toastr.error('We are sorry. An error happened while trying to update the password.', 'ELI');
                }
                this.saving = false;
            });
        } else {
            this._Toastr.warning("Please enter a valid password.", "ELI");
            this.saving = false;
        }
    }

    clearPasswordInputs() {
        $('#currentPassword').val('');
        $('#password1').val('');
        $('#password2').val('');
    }

    passwordValid(event) {
        console.log(event);
        this.passwordIsValid = event;
        switch (event) {
            case null:
                $('#passWordText').css('color', 'black');
                $('#passWordText').css('display', 'block');
                break

            case 0:
            case 1:
            case 2:
                $('#passWordText').css('color', 'red');
                $('#passWordText').css('display', 'block');
                break;
            case 3:
            case 4:
                $('#passWordText').css('display', 'none');
                break;
        }
    }

    detectChanges() {
        this.madeChanges = true;
    }
}
